module.exports = __webpack_public_path__ + "img/icon_close.1c2b1963.svg";